import { Component, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { OneSignalService } from 'src/app/services/one-signal.service';

@Component({
  selector: 'app-notification-request',
  templateUrl: './notification-request.component.html',
  styleUrls: ['./notification-request.component.scss']
})
export class NotificationRequestComponent implements OnInit {

  constructor(
    private platform: Platform,
    private oneSignalServ: OneSignalService,
    private mdlctrl: ModalController,
    private authServ: AuthService
  ) { }

  ngOnInit() {
  }

  async close() {
    await this.mdlctrl.dismiss();
    localStorage.setItem('notificationDenied', 'true');
  }

  async accept() {

    sessionStorage.setItem('oneSignal', 'true');

    try {
      if (this.platform.is('capacitor')) {
        this.oneSignalServ.cordovapush();
      } else {
        this.oneSignalServ.webpush();
      }
    } catch { }

    this.authServ.control();

    if (this.authServ.isLogged && localStorage.getItem('oneSignal')) {
      try {
        await this.oneSignalServ.oneSignalLogin();
      } catch { }
    }

    this.close();
  }
}
